module.exports = __webpack_public_path__ + "static/media/m4tj73.a04f3fa6.png";